import log from 'loglevel';
/**
 * 时间策略上下文
 *
 * @export
 * @class QueryContext
 */
export default class QueryContext {
  constructor(dbCtrl) {
    this.controller = dbCtrl;
    this.cid = '';
    this._strategy = null;
  }

  destroy() {
    this.controller = null;
    this._strategy = null;
  }

  /**
   * 上下文执行查询方法
   *
   * @param start
   * @param end
   * @returns {Promise<*>}
   */
  async execute(start, end) {
    if (!this.strategy) {
      log.warn('query strategy is null');
      return;
    }

    if (!this.controller) {
      log.warn('dbController is null');
      return;
    }

    // 设置查询控制器
    this.strategy.dbController = this.controller;

    this.strategy.cid = this.cid;
    const result = await this.strategy.query(start, end);

    if (result.length > 0) {
      log.info(`query strategy: ${this.strategy.type}. start: ${start}, end: ${end}`);
    }

    return result;
  }

  set strategy(val) {
    this._strategy = val;
  }

  get strategy() {
    return this._strategy;
  }
}
